import React, { useEffect, useRef } from "react";
import { lineChart, registerTheme } from "tui-chart";
import "tui-chart/dist/tui-chart.css";

const theme = {
  title: { color: "#8791af" },
  xAxis: { label: { color: "#8791af" }, tickColor: "#8791af" },
  yAxis: { label: { color: "#8791af" }, tickColor: "#8791af" },
  legend: { label: { color: "#8791af" } },
};

registerTheme("myTheme", theme);

function LineChart({ categories, series, title }) {
  const chartRef = useRef(null);

  useEffect(() => {
    const container = chartRef.current;
    if (!container) return;
    if (!categories || categories.length === 0 || !series || series.length === 0) return;

    const data = { categories, series };

    const options = {
      chart: { width: container.offsetWidth, height: 320, title },
      series: { showDot: categories.length <= 30, spline: true },
      yAxis: { title: "건수", min: 0 },
      xAxis: { title: "", rotateLabel: categories.length > 12 },
      legend: { align: "top" },
      theme: "myTheme",
    };

    const chart = lineChart(container, data, options);

    const handleResize = () => {
      chart.resize({ width: container.offsetWidth, height: 320 });
    };
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
      chart.destroy();
    };
  }, [categories, series, title]);

  return <div ref={chartRef} style={{ width: "100%" }} />;
}

export default LineChart;
